export const proffArticlePreviewImageHeight = 150;
